export interface UserInfo {
	id: string;
	email: string;
	school?: string;
	gradYear?: number;
	examDate?: string;
	firstName?: string;
	lastName?: string;
	name?: string;
	country?: string;
	specialities?: string[];
	profession?: string;
}
export type AchievementType = {
	title: string;
	description: string;
	points: number;
	level: number;
	events: number;
	totalEvents: number;
	usersEarned: number;
	icon: {
		url: string;
		backgroundColor: string;
	};
};
